import type {
  DrillingMultiAnalysisWidgetEntity,
  TDrillingMultiAnalysisSerializedInternalState,
} from 'src/pages/dashboard/features/drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function serializeDrillingMultiAnalysisTemplate(
  widget: DrillingMultiAnalysisWidgetEntity,
): TSerializedWidgetTemplate {
  const internalState: TDrillingMultiAnalysisSerializedInternalState = {
    wellId: null,
    stateParams: widget.stateParams,
  };

  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
